import { useState } from "react";
import { useHistory } from 'react-router-dom';
import { Menu, Button } from 'semantic-ui-react';
import icons from '../../shared/icons';
import Strings from '../../constants/Strings';
import classes from "../../_style/_style.module.scss";

const Header = props => {
    const [activeItem, setActiveItem] = useState("");
    let history = useHistory();
    const handleItemClick = (e, { name }) => {
        setActiveItem(name);
        history.push(name)
    }
    return <Menu borderless={true}>
        <Menu.Item>
            <img src={icons.logo} alt="renet" style={{ width: 150 }} />
        </Menu.Item>

        <Menu.Item
            name='home'
            active={activeItem === 'home'}
            onClick={handleItemClick}
        >
            <label className={classes.header__label}>{Strings.header.home_page}</label>
        </Menu.Item>

        <Menu.Item
            name='about'
            active={activeItem === 'about'}
            onClick={handleItemClick}
        >
            <label className={classes.header__label}>{Strings.header.about_page}</label>
        </Menu.Item>

        <Menu.Item
            name='ombox'
            active={activeItem === 'ombox'}
            onClick={handleItemClick}
        >

            <label className={classes.header__label}>{Strings.header.ombox_page}</label>
        </Menu.Item>

        <Menu.Item position='right'>
            <Button positive className={classes.header__button} onClick={(e) => { handleItemClick(e, { name: 'contact' }) }}>{Strings.header.contact_page}</Button>
        </Menu.Item>
    </Menu>
}

export default Header;